/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bad-trends': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<rect pid="0" x="18" y="18.001" width="4" height="7" rx="1.5" ry="1.5"/><rect pid="1" x="11" y="13.001" width="4" height="12" rx="1.5" ry="1.5"/><rect pid="2" x="4" y="7.001" width="4" height="18" rx="1.5" ry="1.5"/><path pid="3" d="M23 11.501a.5.5 0 0 0-1 0v2.724A96.582 96.582 0 0 0 4.762.075a.5.5 0 0 0-.524.852 95.343 95.343 0 0 1 17.12 14.074H18.5a.5.5 0 1 0 0 1h4a.498.498 0 0 0 .185-.037.515.515 0 0 0 .073-.045.476.476 0 0 0 .078-.048l.007-.009a2.227 2.227 0 0 0 .113-.16.492.492 0 0 0 .018-.073.498.498 0 0 0 .024-.116L23 15.5z"/>'
  }
})
